"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.gatekeeperUrl = void 0;
const config = {
    production: {
        gatekeeperUrl: 'https://gatekeeper-service.rtspro.com',
    },
    development: {
        gatekeeperUrl: 'https://gatekeeper-service.rtspro.dev',
    },
    local: {
        gatekeeperUrl: 'http://localhost:4015',
    },
    test: {
        gatekeeperUrl: 'http://localhost:4015',
    }
};
exports.gatekeeperUrl = config[(_a = process.env.NODE_ENV) !== null && _a !== void 0 ? _a : 'local'].gatekeeperUrl;
